module.exports = __webpack_public_path__ + "assets/img/driver-btn-0ecb10d2.png";